import React, { useState } from 'react';
import { Form, Input, Button, Image, Typography, message, Card } from 'antd';
import { useNavigate } from 'react-router-dom';
import axios from '../util/axiosConfig';
import { useAuth } from '../context/AuthContext';
import brigadeImg from '../assets/images/brigade.png';
import digiLogo from '../assets/images/DIGITIDE_logo.png';

const { Title } = Typography;

const LoginPage: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { login } = useAuth();

    const onFinish = async (values: any) => {
        setLoading(true);

        try {
            const response = await axios.post('/api/v1/auth/signin', {
                email: values.email,
                password: values.password,
            });

            if (response?.status === 200 && response?.data.message) {
                message.success('Login success');
                login({
                    token: response?.data?.data?.token,
                    username: response?.data?.data?.username,
                    email: response?.data?.data?.email,
                    roles: response?.data?.data?.roles,
                    userID: response?.data?.data?.id
                });
                localStorage.setItem('token', response?.data?.data?.token);
                localStorage.setItem('refreshToken', response?.data?.data?.refreshToken);
                localStorage.setItem('authenticated', 'true');
               
                navigate('/dashboard');
            } else {
                message.error('Login failed. Please check your credentials.');
            }
        } catch (error) {
            console.error('Login error:', error);
            message.error('An error occurred during login. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <Card bordered={false} className="login-card">
                <div className="login-header">
                    {/* <Image src={brigadeImg} className="brigade-logo" preview={false} hidden={true} /> */}
                    <Title level={4} className="login-title">Vendor Invoice Management</Title>
                    <Image src={digiLogo} className="conneqt-logo" preview={false} />
                </div>
                <Form
                    name="login"
                    className="login-form"
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Form.Item
                        name="email"
                        rules={[{ required: true, message: 'Please input your email!' }]}
                    >
                        <Input placeholder="Email" />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: 'Please input your password!' }]}
                    >
                        <Input.Password placeholder="Password" />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" loading={loading} className="login-button">
                            Log in
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default LoginPage;